exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 34
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15